import { api } from "../../config/api";
import { appApi } from "./appApi";

export interface NotificationsBaseArgs {
  device_token: string | null;
  session_id: string | null;
}

export interface NotificationBannerRow {
  banner_id: number;
  name: string;
  description: string;
  deployment_start_time: string;
  deployment_end_time: string;
  banner_start_time: string;
  banner_end_time: string;
  deployment_status: string;
  deployment_category: string;
  release_notes: string;
  created_by?: string;
  updated_by?: string;
}

export interface NotificationsApiResponse<T = unknown> {
  success: boolean;
  data?: T;
  errors?: string[] | string;
  error_code?: string | null;
}

export const notificationsApi = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getSystemBanners: builder.query<
      NotificationsApiResponse<{ banners?: NotificationBannerRow[] }>,
      NotificationsBaseArgs
    >({
      query: (args) => ({
        url: api.urls.GET_NOTIFICATION || "/users/getbanners/",
        method: "POST",
        body: {
          device_token: args.device_token ?? "",
          session_id: args.session_id ?? "",
        },
      }),
      providesTags: ["Notifications"],
    }),
    getNotifications: builder.mutation<
      NotificationsApiResponse<{ banners?: NotificationBannerRow[] }>,
      NotificationsBaseArgs
    >({
      query: (args) => ({
        url: api.urls.GET_NOTIFICATION || "/users/getbanners/",
        method: "POST",
        body: {
          device_token: args.device_token ?? "",
          session_id: args.session_id ?? "",
        },
      }),
      invalidatesTags: ["Notifications"],
    }),
    maintainNotification: builder.mutation<
      NotificationsApiResponse<unknown>,
      Record<string, unknown>
    >({
      query: (body) => ({
        url: api.urls.CREATE_NOTIFICATION || "/users/maintainbanners/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetSystemBannersQuery,
  useGetNotificationsMutation,
  useMaintainNotificationMutation,
} = notificationsApi;
